import { requestFlow, requestStatus } from 'src/lib/services/api/request-api';

export const requestsResponseHelper: {
  isFolder: (request: { flow: string | any }) => boolean;
  isQueued: (request: { status: string | any }) => boolean;
  isEditing: (request: { status: string | any }) => boolean;
  isDelivered: (request: { status: string | any }) => boolean;
  isCompleted: (request: { status: string | any }) => boolean;
  hasVideoRevision: (request: { revisions_count?: number }) => boolean;
  hasAnyRevision: (request: { revisions_count?: number }) => boolean;
  isApproved: (request: { approved_at?: string | null }) => boolean;
  needsReedit: (request: { requested_reedit_at?: string | null }) => boolean;
  canBeTransformedToMultiOutcome: (request: {
    can_be_transformed_to_multi_outcome?: boolean;
    flow?: string | any;
    parent_id?: string | null;
    with_multiple_outcomes?: boolean;
  }) => boolean;
} = {
  isFolder: ({ flow }) => [requestFlow.repurpose, requestFlow.multiOutcome].includes(flow),
  isQueued: ({ status }) => requestStatus.queued === status,
  isEditing: ({ status }) => requestStatus.currentlyEditing === status,
  isDelivered: ({ status }) => requestStatus.delivered === status,
  isCompleted: ({ status }) => requestStatus.complete === status,
  hasVideoRevision: ({ revisions_count }) => (revisions_count ?? 0) > 1,
  hasAnyRevision: ({ revisions_count }) => (revisions_count ?? 0) > 0,
  isApproved: ({ approved_at }) => !!approved_at,
  needsReedit: ({ requested_reedit_at }) => !!requested_reedit_at,
  // Server gates timing (be-core #2513): allowed while Queued or mid-edit,
  // blocked once any work is delivered. Fail-closed if the flag is absent (e.g.
  // backend not yet deployed) so we never show a button that 500s.
  //
  // Transform only ever applies to a *true single* request: it must NOT already
  // be a multi-outcome project (flow 'multi_outcome'), a child outcome of one
  // (flow 'outcome' / parent_id set), or a repurpose folder. The server flag has
  // been leaking `true` onto those rows (Karina #2513 re-open: Transform showed
  // on DOOR #1, Lithuania Outcome #1), so guard structurally on the FE too —
  // across List and Kanban, since both views call through here.
  canBeTransformedToMultiOutcome: ({
    can_be_transformed_to_multi_outcome,
    flow,
    parent_id,
    with_multiple_outcomes,
  }) =>
    can_be_transformed_to_multi_outcome === true &&
    flow === requestFlow.default &&
    !parent_id &&
    !with_multiple_outcomes,
};
